import { FC } from 'react';
import { Box } from '@chakra-ui/react';
import Hero from 'components/landing/Hero';
import Stats from 'components/landing/Stats';
import CTA from 'components/landing/CTA';
import UniversalVault from 'components/landing/UniversalVault';
import MultipleRewards from 'components/landing/MultipleRewards';

const LandingPage: FC = () => {
  return (
    <>
      <Box zIndex={3} position='relative'>
        <Hero />
        <Stats />
        <MultipleRewards />
        <UniversalVault />
        <CTA />
      </Box>
    </>
  );
};

export default LandingPage;
